class Page {
  page = 1;
  perPage = 10;
  searchData: any = {};
}

export class SearchPageInfo {
  userTablePage = new Page();
}
